angular
  .module('contributor')

  .factory('TaskCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class TaskCrud extends Crud {
        constructor(list) {
          super(
            'task' + (list || ''),
            '@@apiUrl' + '/tasks' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return TaskCrud;
    }
  ]);
